'use client';

import { safeSessionStorage } from '@/lib/storage/safe-storage';
import { AFFILIATE_STORAGE_KEY } from '@/lib/utils/affiliate';

/**
 * Sets the standalone affiliate value (session-scoped) if not already set.
 * Distinguishes orders from standalone app vs embedded widget.
 */
export function initStandaloneAffiliate(standaloneAffiliateId: string | undefined): void {
  if (!standaloneAffiliateId) return;
  if (safeSessionStorage.getItem(AFFILIATE_STORAGE_KEY)) return;

  safeSessionStorage.setItem(AFFILIATE_STORAGE_KEY, standaloneAffiliateId);
}
